/**
 * App Reducers
 */
import {combineReducers} from 'redux';

import {reducer as reduxFormReducer} from 'redux-form';
import {lineItemsDragDropReducerKey, realtimeDataReducerKey} from '../constants';
import authUserReducer from './AuthUserReducer';
import data from './DataReducer.ts';
import {lineItemsDragDropReducer} from './LineItemsDnD';
import {realtimeReducer} from './RealtimeReducer';
import settings from './settings';
import sidebarReducer from './SidebarReducer';
import {uploadingDocumentsArray} from './UploadingDocuments';

const reducers = combineReducers({
    data,
    settings,
    sidebar: sidebarReducer,
    authUser: authUserReducer,
    form: reduxFormReducer,
    uploadingDocuments: uploadingDocumentsArray,
    [lineItemsDragDropReducerKey]: lineItemsDragDropReducer,
    [realtimeDataReducerKey]: realtimeReducer
});

export default reducers;
